import { ApiError } from '../api';

/**
 * What the server said, printed where the press happened.
 *
 * Mutations here were written as `useMutation({ mutationFn, onSuccess })` and nothing else, so a
 * failed one changed the screen in no way whatsoever — a reporter clicked Complete, Post and
 * "Take it on", got three 403s with a clear message on each, and saw the page sit still. The
 * refusal was already well worded by the server; it simply had nowhere to go.
 *
 * The server's own message, verbatim, rather than a paraphrase: it knows *which* rule refused,
 * and every rewording this component could do would be less specific than what it was handed.
 * Anything that is not an `ApiError` never reached the server, so it gets the one sentence that
 * is true of all of them.
 */
export function FailureNote({
  error,
  testId = 'action-error',
}: {
  error: unknown;
  /** Distinct where two of these can be on screen at once, so a locator stays unambiguous. */
  testId?: string;
}) {
  if (!error) return null;
  const text =
    error instanceof ApiError
      ? error.message
      : 'That did not go through. Check your connection and try again.';
  return (
    <p className="error" role="status" data-testid={testId}>
      {text}
    </p>
  );
}
